import { PropsWithChildren } from 'react';

/**
 * Jest Example Test with Testing-Library
 * @param {PropsWithChildren} children
 * @returns Jest example
 */
export const EpTestExample = ({ children }: PropsWithChildren) => {
  return <h2>{children}</h2>;
};
